import React, { Component } from 'react';
import { isNull, isEmpty } from 'lodash';

import './style.scss';
import Loading from '../../common/loading';
import { Page, PageHeader, Card, SearchInput, DataList, TextButton, FlushButtons, Country, matchSearch } from '../../common/ui';
import ModalPricing from '../../common/modal/modalPricing';
import { returnNationality } from '../../common/actions/returnNationality';
import { randomString } from '../../common/actions/randomString';
import { compareString } from '../../common/actions/compareString';
import { returnTypeName } from '../../common/actions/returnTypeName';
import { API_PREFERENCES, COUNTRY_PRICINGS } from '../../config';
import { controlRole } from '../../common/actions/controlRole';
import { withNavigate } from '../../utility';
import axiosInstance from '../../axiosInstance';

const priceFormat = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', useGrouping: 'always' });

class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // contiene la lista dei pricing restituita dopo la chiamata al BE
            getPricingList: [],

            // chiave di riferimento nel caso si volesse editare o rimuovere
            keyReference: '',
            // sottochiave di riferimento nel caso si volesse editare o rimuovere
            subKeyReference: '',
            // tutto il contenuto della chiave selezionata (variabile temporanea di appoggio)
            keyContentReference: '',

            // usato per avere come riferimento l'elemento da sostituire o eliminare durante l'edit
            keyElement: '',

            // elemento di riferimento nel caso si volesse editare o rimuovere
            elementReference: '',

            hasClickNewKey: false,
            hasClickNewElement: false,
            hasClickEdit: false,
            hasClickRemoveKey: false,
            hasClickExclusion: false,
            hasClickInclude: false,

            // variabili di appoggio per salvare nello stato i prezzi e le esclusioni cui voglio apportare modifiche
            allElementPricings: [],
            allElementExclusions: [],

            shortId: randomString(),

            modal: false,
            isLoading: true,

            loadingForRole: true,

            // testo di ricerca nella lista dei paesi
            search: ''
        }
        this.getPricingList = this.getPricingList.bind(this);
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare il pricing, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (!controlRole(this.props.role.preferences, "api/Preferences", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare il pricing!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getPricingList();
                    this.props.getProductList();
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare il pricing, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (!controlRole(this.props.role.preferences, "api/Preferences", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare il pricing!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getPricingList();
                    this.props.getProductList();
                }
            }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }


    /**
     * Chiama il BE e ritorna la lista degli indirizzi dei pricing
     * 
     * @return type array
     */
    getPricingList = async () => {
        this.setState({ isLoading: true });
        try {
            let response = await axiosInstance.get(`${API_PREFERENCES}/${COUNTRY_PRICINGS}`);
            this.setState({
                getPricingList: response.data,
                isLoading: false,
            });
        } catch (result) {
            const { errorNotify } = this.props;
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                switch (result.response) {
                    default: errorNotify(`Error ${result.response.status} su ${API_PREFERENCES} - GET`); break;
                }
            }
        }
    }

    /**
     * Usato solo per chiudere la modale, poiche resetta tutto lo state
     */
    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
        this.setState({
            hasClickNewKey: false,
            hasClickEdit: false,
            hasClickNewElement: false,
            hasClickRemoveKey: false,
            hasClickExclusion: false,
            hasClickInclude: false,
            keyReference: '',
            subKeyReference: '',
            keyContentReference: '',
            allElementPricings: [],
            allElementExclusions: [],
            elementReference: '',
            keyElement: ''
        });
    }

    /**
     * Se viene cliccato il pulsante nuova nazione, attiva la modale per inviare una nuova chiave
     */
    hasClickNewKey = () => {
        this.setState({ hasClickNewKey: true });

        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante nuovo elemento, attiva la modale per inviare un nuovo elemento alla key(country).
     */
    hasClickNewElement = (key, subKey) => {
        this.setState({
            hasClickNewElement: true,
            keyReference: key,
            subKeyReference: subKey,
        });

        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante rimuovi key, attiva la modale per rimuovere la nazione
     */
    hasClickRemoveKey = (key) => {
        this.setState({
            hasClickRemoveKey: true,
            keyReference: key
        });
        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante edit pricing, attiva la modale per inviare modifiche su quel pricing e quel prodotto.
     * 
     * @param keyName è il nome della chiave, in questo caso il country (es: IT)
     * @param keyContent è il contenuto di tutta la chiave (es: Contenuto di IT)
     * @param subKey è il nome contenuto nella chiave (es: Pricings, Exclusions)
     * @param element è l'elemento che deve essere modificato (es: {"ProductName":"blabla",....}) 
     * @param keyElement è la chiave dell'indice dell'elemento che deve essere sostituito
     * 
     */
    hasClickEdit = (keyName, keyContent, subKey, element, keyElement) => {
        this.setState({
            hasClickEdit: true,
            keyReference: keyName,
            keyContentReference: keyContent,
            subKeyReference: subKey,
            elementReference: element,
            keyElement: keyElement
        });

        setTimeout(() => {
            this.getAllElement();
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante escludi, attiva la modale di conferma per escludere quel prodotto.
     * 
     * @param keyName è il nome della chiave, in questo caso il country (es: IT)
     * @param keyContent è il contenuto di tutta la chiave (es: Contenuto di IT)
     * @param subKey è il nome contenuto nella chiave (es: Pricings, Exclusions)
     * @param element è l'elemento che deve essere modificato (es: {"ProductName":"blabla",....}) 
     * @param keyElement è la chiave dell'indice dell'elemento che deve essere sostituito
     * 
     */
    hasClickExclusion = (keyName, keyContent, subKey, element, keyElement) => {
        this.setState({
            hasClickExclusion: true,
            keyReference: keyName,
            keyContentReference: keyContent,
            subKeyReference: subKey,
            elementReference: element,
            keyElement: keyElement
        });

        setTimeout(() => {
            this.getAllElement();
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante escludi, attiva la modale di conferma per escludere quel prodotto.
     * 
     * @param keyName è il nome della chiave, in questo caso il country (es: IT)
     * @param keyContent è il contenuto di tutta la chiave (es: Contenuto di IT)
     * @param subKey è il nome contenuto nella chiave (es: Pricings, Exclusions)
     * @param element è l'elemento che deve essere modificato (es: {"ProductName":"blabla",....}) 
     * @param keyElement è la chiave dell'indice dell'elemento che deve essere sostituito
     * 
     */
    hasClickInclude = (keyName, keyContent, subKey, element, keyElement) => {
        this.setState({
            hasClickInclude: true,
            keyReference: keyName,
            keyContentReference: keyContent,
            subKeyReference: subKey,
            elementReference: element,
            keyElement: keyElement
        });

        setTimeout(() => {
            this.getAllElement();
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Aggiunge una nuova chiave alla lista.
     * Di default aggiunge tutti i prezzi di che il BE mi torna, e nelle esclusioni nulla.
     * Poi se voglio modificare qualcosa, modifico quello che mi pare.
     * 
     * @param key è la nuova chiave
     */
    addKey = (key) => {
        const { preferences } = this.props;

        let dataPricings = [];

        // eslint-disable-next-line
        preferences.allProducts.map(el => {
            dataPricings.push({
                "ProductName": el.name,
                "ProductType": el.type,
                "Price": el.price.toString()
            })
        });

        let data = {
            [key]: {
                "Pricings": dataPricings,
                "Exclusions": []
            }
        }

        this.props.sendEditPreferences(COUNTRY_PRICINGS, data);
        this.toggleModal();

        setTimeout(() => {
            this.getPricingList();
        }, 1000)
    }

    /**
     * Modifica un prezzo della lista, e rimanda tutto al BE.
     * 
     * @param key è la chiave principale (es. IT)
     * @param subKey è la sottochiave (es. Pricings, Exclusions)
     * @param data è l'oggetto completo (contiene: ProductType, ProductName, e se è un pricing contiene anche Price)
     */
    editKey = (key, subKey, data) => {
        let listTemp = [];
        let listTemp2 = [];
        let dataTemp = {};
        const { preferences } = this.props;

        // è un pricing da modificare?
        if (this.state.hasClickEdit && compareString(subKey, 'pricings')) {
            // eslint-disable-next-line
            this.state.allElementPricings.map(el => {
                listTemp.push(el);
            });

            // sostituisco il vecchio indirizzo elemento pricing con il nuovo
            listTemp.splice(this.state.keyElement, 1, data);

            // la chiave iniziale aveva anche le exclusions, quindi reinserisco quello che avevo salvate nello state in precedenza
            dataTemp = {
                [key]: {
                    [subKey]: listTemp,
                    "Exclusions": this.state.allElementExclusions
                }
            }
        }

        // è un exclusion?
        if (this.state.hasClickExclusion) {
            // eslint-disable-next-line
            this.state.allElementExclusions.map(el => {
                listTemp.push(el);
            });

            // aggiungo il nuovo elemento alle esclusioni
            listTemp.push(data);

            // eslint-disable-next-line
            this.state.allElementPricings.map(el => {
                listTemp2.push(el);
            });

            // rimuovo l'elemento dal pricings
            listTemp2.splice(this.state.keyElement, 1);

            // reimposto la chiave iniziale togliendo l'elemento dal pricings (listTemp2) e aggiungendo alle exclusions (listTemp) il nuovo elemento
            dataTemp = {
                [key]: {
                    "Pricings": listTemp2,
                    "Exclusions": listTemp
                }
            }
        }

        // è un inclusione?
        if (this.state.hasClickInclude) {
            let newData = {};

            // eslint-disable-next-line
            this.state.allElementPricings.map(el => {
                listTemp2.push(el);
            });

            // cerco il prodotto nella lista dei prodotti che ho nello store che lo stesso productName e prendo il prezzo di default
            // eslint-disable-next-line
            preferences.allProducts.map(el => {
                if (compareString(el.name, data.ProductName)) {
                    newData = {
                        "ProductName": data.ProductName,
                        "ProductType": data.ProductType,
                        "Price": el.price.toString()
                    }
                }
            })

            // aggiungo il nuovo elemento ai prodotti prezzati
            listTemp2.push(newData);

            // eslint-disable-next-line
            this.state.allElementExclusions.map(el => {
                listTemp.push(el);
            });

            // rimuovo l'elemento dalle escluzioni
            listTemp.splice(this.state.keyElement, 1);

            // reimposto la chiave iniziale togliendo l'elemento dalle esclusioni (listTemp) e aggiungendo alla lista dei pricings (listTemp2) il nuovo elemento
            dataTemp = {
                [key]: {
                    "Pricings": listTemp2,
                    "Exclusions": listTemp
                }
            }
        }

        this.props.sendEditPreferences(COUNTRY_PRICINGS, dataTemp);
        this.toggleModal();

        setTimeout(() => {
            this.getPricingList();
        }, 1000);
    }

    /**
     * Rimuove una key (country) dalla lista.
     * 
     * @param key è la chiave da rimuovere
     */
    removeKey = (key) => {
        this.props.deleteKeyFromList(COUNTRY_PRICINGS, key);
        this.toggleModal();
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.getPricingList();
        }, 1000);
    }

    /**
     * Ogni volta che l'utente clicca 'modifica un pricing',
     * questa funzione prende tutti i gli elementi contenuti nell'array Pricings e Exclusions riferiti a quella chiave e 
     * li inserisce in delle variabili temporanee in modo da tenerli
     * salvati nello state per una possibile put futura.
     * 
     * Esempio: se voglio modificare un prezzo che si trova all'interno id Pricings di IT,
     * questa funzione in allElementPricings inserisce tutti gli elementi di Pricings e tutte
     * le Exclusions in allElementExclusions
     */
    getAllElement = () => {
        // eslint-disable-next-line
        Object.keys(this.state.keyContentReference).map(item => {
            if (compareString(item, 'Pricings') && !isEmpty(this.state.keyContentReference[item])) {
                this.setState({ allElementPricings: this.state.keyContentReference[item] });
            }
            if (compareString(item, 'Exclusions') && !isEmpty(this.state.keyContentReference[item])) {
                this.setState({ allElementExclusions: this.state.keyContentReference[item] });
            }
        });
    }

    render() {
        const { role } = this.props;
        const { getPricingList, search } = this.state;

        const canEdit = controlRole(role.preferences, "api/Preferences", "PUT");
        const allCountries = isNull(getPricingList) ? [] : Object.keys(getPricingList);
        const countries = allCountries.filter(code => matchSearch(search, code, returnNationality(code)));

        const productName = (elem) => `${returnTypeName(elem.ProductType)} - ${returnTypeName(elem.ProductName)}`;
        const sectionLabel = (key) => compareString(key, 'pricings') ? 'Prezzi' : compareString(key, 'Exclusions') ? 'Esclusioni' : key;

        return (
            <Page>
                <PageHeader
                    title="Pricing"
                    subtitle={`${allCountries.length} paesi`}
                    actions={
                        <>
                            <FlushButtons
                                canFlush={controlRole(role.preferences, "api/Preferences/flush", "POST")}
                                canFlushConfig={controlRole(role.configFlush, "api/Config", "POST")}
                                onFlush={this.props.flush}
                                onFlushConfig={this.props.flushConfig}
                            />
                            {
                                canEdit &&
                                <button type="button" className="btn btn-sm btn-success" onClick={this.hasClickNewKey}>
                                    <i className="fas fa-plus" aria-hidden="true" /> Nuovo paese
                                </button>
                            }
                        </>
                    }
                />

                {
                    (this.props.preferences.isLoading || this.state.isLoading || this.state.loadingForRole) ? <Loading /> :
                        <Card>
                            <div className="uiToolbar">
                                <SearchInput value={search} onChange={value => this.setState({ search: value })} placeholder="Cerca per paese o sigla" />
                                {search && <span className="uiCount">{countries.length} risultati</span>}
                            </div>

                            {
                                countries.length === 0 ?
                                    <div className="uiEmpty">{search ? 'Nessun paese trovato' : 'Nessun paese'}</div>
                                    :
                                    countries.map(item => { // paese (es. IT)
                                        const sections = Object.keys(getPricingList[item]);
                                        const count = (key) => (getPricingList[item][key] || []).length;

                                        return (
                                            <details className="pricingCountry" key={item}>
                                                <summary>
                                                    <i className="fas fa-chevron-right pricingChevron" aria-hidden="true" />
                                                    <Country code={item} showCode />
                                                    <span className="pricingCounts">
                                                        {sections.map(key => <span key={key}>{count(key)} {sectionLabel(key).toLowerCase()}</span>)}
                                                    </span>
                                                    <TextButton
                                                        icon="far fa-trash-alt"
                                                        variant="danger"
                                                        title={"Elimina la chiave " + item}
                                                        onClick={(event) => {
                                                            // non deve aprire/chiudere il paese
                                                            event.preventDefault();
                                                            event.stopPropagation();
                                                            this.hasClickRemoveKey(item);
                                                        }}
                                                    >
                                                        <span className="pricingDeleteLabel">Elimina</span>
                                                    </TextButton>
                                                </summary>

                                                <div className="pricingSections">
                                                    {
                                                        sections.map(el => { // sottochiavi (Pricings, Exclusions)
                                                            const isPricing = compareString(el, 'pricings');
                                                            const isExclusion = compareString(el, 'Exclusions');
                                                            const rows = (getPricingList[item][el] || []).map((elem, index) => ({ ...elem, index }));

                                                            return (
                                                                <div className="pricingSection" key={el}>
                                                                    <h4>{sectionLabel(el)}</h4>
                                                                    <DataList
                                                                        columns={[
                                                                            { key: 'product', label: 'Prodotto', width: 'minmax(0, 2fr)', render: elem => productName(elem) },
                                                                            ...(isPricing ? [{ key: 'Price', label: 'Prezzo', width: '120px', align: 'right', numeric: true, render: elem => priceFormat.format(Number(elem.Price) || 0) }] : [])
                                                                        ]}
                                                                        rows={rows}
                                                                        rowKey={elem => `${elem.index}-${elem.ProductType}-${elem.ProductName}`}
                                                                        empty="Vuoto"
                                                                        actionsWidth={isPricing ? '190px' : '110px'}
                                                                        actions={
                                                                            canEdit && (isPricing || isExclusion) ?
                                                                                elem => isPricing ?
                                                                                    <>
                                                                                        <TextButton icon="far fa-edit" onClick={() => { this.hasClickEdit(item, getPricingList[item], el, elem, elem.index) }}>Modifica</TextButton>
                                                                                        <TextButton icon="fas fa-sign-out-alt" variant="danger" onClick={() => { this.hasClickExclusion(item, getPricingList[item], el, elem, elem.index) }}>Escludi</TextButton>
                                                                                    </>
                                                                                    :
                                                                                    <TextButton icon="fas fa-sign-in-alt" variant="success" onClick={() => { this.hasClickInclude(item, getPricingList[item], el, elem, elem.index) }}>Includi</TextButton>
                                                                                : undefined
                                                                        }
                                                                    />
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </details>
                                        );
                                    })
                            }
                        </Card>
                }

                {
                    (
                        this.state.hasClickNewKey ||
                        this.state.hasClickRemoveKey ||
                        this.state.hasClickEdit ||
                        this.state.hasClickExclusion ||
                        this.state.hasClickInclude
                    ) &&
                    <ModalPricing
                        titleModal={
                            this.state.hasClickNewKey ? 'Nuovo Country' :
                                this.state.hasClickRemoveKey ? 'Rimuovi Country' :
                                    this.state.hasClickEdit ? 'Modifica Prodotto' :
                                        this.state.hasClickExclusion ? 'Escludi Prodotto' :
                                            this.state.hasClickInclude ? 'Includi Prodotto' : ''
                        }
                        type={
                            this.state.hasClickNewKey ? 'newKey' :
                                this.state.hasClickRemoveKey ? 'removeKey' :
                                    this.state.hasClickEdit ? 'edit' :
                                        this.state.hasClickExclusion ? 'exclude' :
                                            this.state.hasClickInclude ? 'include' : ''
                        }
                        toggle={this.toggleModal}
                        stateModal={this.state.modal}

                        allElementPricings={this.state.allElementPricings}
                        allElementExclusions={this.state.allElementExclusions}

                        clickNewKey={this.addKey}
                        clickEdit={this.editKey}
                        clickRemoveKey={this.removeKey}

                        keyReference={this.state.keyReference}
                        subKeyReference={this.state.subKeyReference}
                        elementReference={this.state.elementReference}

                        preferences={this.props.preferences}
                        key={this.state.shortId}
                        errorNotify={this.props.errorNotify}
                    />
                }
            </Page>
        )
    }
}

export default withNavigate(Pricing);
